import {useCallback, useState} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {type WpIssueMarkState} from '@/pages/components/audit/adjustment/adjust/dialogs/utils/wpStatusSaveHelper';

const DEFAULT_ISSUE_STATE: WpIssueMarkState = {
    marked: false,
    remark: '',
    outstanding: false,
    outstandingRemark: '',
    valid: true,
};

export interface WpIssueMarkPayloadLine {
    fsId?: number;
    wpStatus?: number | null;
    wpIssueRemark?: string | null;
    outstanding?: boolean | null;
    outstandingRemark?: string | null;
}

export function useWpIssueMark(params: {
    companyId?: number;
    annualId?: number;
    line?: WpIssueMarkPayloadLine | null;
    categoryLine?: {fsId?: number} | null;
}) {
    const {companyId, annualId} = params;
    const queryClient = useQueryClient();
    const [issueMarkState, setIssueMarkState] = useState<WpIssueMarkState>(DEFAULT_ISSUE_STATE);

    const validateIssueMarkBeforeSave = useCallback((): boolean => {
        return issueMarkState.valid;
    }, [issueMarkState.valid]);

    /** Issue-only save path: refresh issue chip; list 无感由 WP saveOrUpdate notify 负责，此处勿再 invalidate list */
    const invalidateAdjustmentListAfterSave = useCallback(async () => {
        if (companyId && annualId) {
            await queryClient.invalidateQueries({
                queryKey: ['audit-fs-wp-issue', companyId, annualId],
            });
        }
    }, [annualId, companyId, queryClient]);

    return {
        issueMarkState,
        setIssueMarkState,
        validateIssueMarkBeforeSave,
        invalidateAdjustmentListAfterSave,
    };
}
